/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadScreenerLeadInfoState
 */
export interface LeadScreenerLeadInfoState {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    code?: string;
    /**
     * 
     */
    country_id?: string;
}

/**
 * Check if a given object implements the LeadScreenerLeadInfoState interface.
 */
export function instanceOfLeadScreenerLeadInfoState(value: object): value is LeadScreenerLeadInfoState {
    return true;
}

export function LeadScreenerLeadInfoStateFromJSON(json: any): LeadScreenerLeadInfoState {
    return LeadScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function LeadScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadInfoState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'country_id': json['country_id'] == null ? undefined : json['country_id'],
    };
}

export function LeadScreenerLeadInfoStateToJSON(json: any): LeadScreenerLeadInfoState {
    return LeadScreenerLeadInfoStateToJSONTyped(json, false);
}

export function LeadScreenerLeadInfoStateToJSONTyped(value?: LeadScreenerLeadInfoState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'country_id': value['country_id'],
    };
}

